import React, { useCallback, useState } from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";

import ConfirmedModal from "components/event/modals/ConfirmedModal";
import NotificationPopup from "components/navigation/notifications/NotificationPopup";
import { useNotificationReceivedListener } from "app/hooks";

const Notification = ({ notification, onClose }) => {
  const { notificationType } = notification;

  if (notificationType === "event_confirmed") {
    return <ConfirmedModal notification={notification} onClose={onClose} />;
  }
  return <NotificationPopup notification={notification} onClose={onClose} />;
};

const NotificationPopupWrapper = () => {
  const drawerRef = React.createRef();
  const [popupNotifications, setPopupNotifications] = useState([]);

  useNotificationReceivedListener(
    useCallback(
      notification => {
        setPopupNotifications(current => [...current, notification]);
      },
      [setPopupNotifications]
    )
  );

  const onPopupClosed = notification => setPopupNotifications(current => (
    current.filter(({ id }) => id !== notification.id)
  ));

  return ReactDOM.createPortal(
    <div ref={drawerRef} className="notification-popup-wrapper">
      {popupNotifications.map(notification => (
        <Notification
          key={notification.id}
          notification={notification}
          onClose={onPopupClosed}
        />
      ))}
    </div>,
    document.body
  );
};

export default withRouter(NotificationPopupWrapper);
